/**
 * Cookie Policy Page
 */

import { PolicyPage } from './PolicyPage';

// Import markdown content - in a real app, this would be loaded dynamically
// For now, we'll create a simple version that can be enhanced later
const cookiePolicyContent = `FLOWRITHM – COOKIE POLICY (FULL LEGAL DRAFT — 2026)
Owned & Operated by Lagori AI LLP
Last Updated: [Insert Date]
This Cookie Policy explains how FlowRithm ("Platform", "we", "us", "our"), a product of Lagori AI LLP, uses cookies and similar tracking technologies across its website, web application, mobile applications, APIs, analytics dashboards, advisor tools, and AI systems.

This Cookie Policy forms part of:
• FlowRithm Privacy Policy
• FlowRithm Terms of Use
By using the Platform, you consent to the use of cookies and tracking technologies as described here.

1. INTRODUCTION
FlowRithm uses cookies, device identifiers, analytics SDKs, and similar technologies to:
• Ensure secure login
• Maintain broker-linked sessions
• Deliver real-time market data
• Provide seamless user experience
• Enhance performance and platform stability
• Measure usage, analytics, and errors
• Enable AI interactions and personalization
• Support advisor/enterprise multi-client environments

2. WHAT ARE COOKIES & TRACKING TECHNOLOGIES?
Cookies are small text files stored on your browser or device when you visit a website.
FlowRithm also uses other tracking technologies such as:
• Local Storage (browser)
• Session Storage
• Secure Storage (mobile apps)
• Analytics SDKs
• Crash-reporting SDKs
• Device identifiers (mobile)
• WebSocket/SSE authentication tokens
• Pixel tags & API event logs
• Encrypted JWT tokens for secure communication

3. COOKIES USED BY FLOWRITHM
FlowRithm uses four broad categories of cookies and tracking tools:

A. Strictly Necessary Cookies (Required for Platform Operation)
These cookies are essential for FlowRithm to function safely and correctly.
Examples include:
• Login session cookies
• Firebase Auth tokens (JWT)
• Session validation tokens
• CSRF protection tokens
• Device recognition tokens
• Broker OAuth session tokens

B. Performance & Analytics Cookies
FlowRithm uses analytics to understand:
• Feature usage
• Session duration
• User navigation
• Real-time performance
• Error diagnostics
• Strategy builder usage flow

C. Preference & Personalization Cookies
These store user-selected settings such as:
• Light/Dark theme
• Dashboard layout
• Default broker for execution
• Watchlist sorting preferences
• Chart layout & indicators
• AI assistant language preferences

D. Marketing, Communication & Notification Cookies (Optional)
FlowRithm does not run ads, but may use cookies for:
• Email communication tracking
• Push notification settings
• Product announcements
• Feature updates
• User onboarding flow

4. MANAGING OR DISABLING COOKIES
Users may manage cookies through:
• Browser settings
• Mobile app settings
• Platform privacy settings

Note: Disabling essential cookies may prevent FlowRithm from functioning correctly.

5. CONTACT INFORMATION
For questions, concerns, or cookie-related requests:
Lagori AI LLP
Email: contact@flowrithm.trade`;

export function CookiePolicyPage() {
  return <PolicyPage title="Cookie Policy" content={cookiePolicyContent} />;
}

